<template>
    <div>
        {{ $t('notification.userEmailChanged', { 
            actor: $_.get(activity, 'actorUser.name'), 
            userName: $_.get(activity, 'payload.userName'),
            oldEmail: $_.get(activity, 'payload.oldEmail'),
            newEmail: $_.get(activity, 'payload.newEmail')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserEmailChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

